export let percentageCalc = (percentage, num) => {
    let numberTemp = num;
    if (typeof(num) != 'string') {
        return { 
            val: 0,
            charge: 0
        }
    }  else {
        numberTemp = numberTemp.replace('zł', '');
        numberTemp = numberTemp.replace(',', '.');
        numberTemp = numberTemp.replace(/ /g, '');
        numberTemp = parseFloat(numberTemp).toFixed(2);
        return { 
            val: (numberTemp - (numberTemp * percentage)).toFixed(2),
            charge: (numberTemp * percentage).toFixed(2),
        }
    }
    
}